import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './shared/header/admin.component';
import { AuthComponent } from './shared/auth/auth.component';
import {SharedModule} from './utils/shared.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { LoginService } from './services/login.service';
import { LoginRouteGuard } from './services/auth-guard.service';
import { HttpService } from './services/http.service';
import { HttpModule, RequestOptions, Http } from '@angular/http';
import { UsuarioService } from './services/usuario.service';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { TokenService } from './services/token.service';
import {DynamicScriptLoaderService} from './services/load.service';

import { DatePipe } from '@angular/common';

import 'devextreme-intl';


/*CONFIGURAR IDIOMA*/
import { locale, loadMessages  } from 'devextreme/localization';

const messagesES = require('assets/api/devextreme/es.json');

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig(), http, options);
}

loadMessages(messagesES);
locale(navigator.language);
// locale(navigator.language || navigator.browserLanguage)
/*CONFIGURAR IDIOMA*/

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    AppRoutingModule,
    SharedModule
  ],
  providers: [
    LoginService,
    UsuarioService,
    LoginRouteGuard,
    HttpService,
    DatePipe,
    TokenService, HttpService,
    DynamicScriptLoaderService,
    {
        provide: AuthHttp,
        useFactory: authHttpServiceFactory,
        deps: [Http, RequestOptions]
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts